<template>
  <header>
    <div class="container-fluid bg-primary">
        <div class="container">
            <div class="d-flex flex-sm-row-reverse justify-content-between align-items-center">
                <div v-if="userRoles && userName" class="p-2 text-white">
                    Signed in as {{ userRoles }}: <strong>{{ userName }}</strong>
                </div>
                <div v-if="!userRoles || !userName" class="p-2 text-white">
                    Not signed in
                </div>
                <div class="text-white" style="font-size:70%">
                    Version: {{ version }}
                </div>
            </div>
        </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      version: '',
    };
  },
  computed: {
    userName() {
      return this.$store.getters['User/getCurrentUser'].name ? this.$store.getters['User/getCurrentUser'].name : '';
    },
    userRoles() {
      return this.$store.getters['User/getCurrentUser'].idToken ? this.$store.getters['User/getCurrentUser'].idToken.roles.join(', ') : '';
    },
  },
  mounted() {
    axios
      .get('/api/version')
      .then((response) => {
        this.version = response.data;
      });
  },
};
</script>
